/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 8th 2022, 1:04:35 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useLocation } from "react-router-dom";
import { useGlobalScope } from "core/providers";
import { URLS } from "core/routes";
import { OSActionButton, EmptyStateActionWrapper, Image, EmphasisText } from "ui-widgets";

export const EmptyTeamsInputCTA = () => {
  const { pathname } = useLocation();

  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  return (
    <EmptyStateActionWrapper
      title={
        <>
          No teams added yet for <EmphasisText>{selectedOrganization?.name}</EmphasisText>
        </>
      }
      description="Teams allow your organization to assign roles in your service delivery process to different staff members."
      illustrationGraphic={<Image className="image-style-A" src="/img/teamwork.png" alt="Onestop Admin" />}
    >
      {pathname !== URLS.allTeams && (
        <OSActionButton variant="contained" size="large" onClick={() => window.location.assign(URLS.allTeams)}>
          Go to Teams
        </OSActionButton>
      )}
    </EmptyStateActionWrapper>
  );
};
